import { http } from './http'
import * as types from './types'

export * from './types'

export const getNotifications = (params: types.IGetNotificationsParams) => {
  return http.get<types.IGetNotificationsData>(`/notifications`, { params })
}
export const getNotificationsCount = (
  params: types.IGetNotificationsCountParams
) => {
  return http.get<types.IGetNotificationsCountData>(`/notifications/count`, {
    params,
  })
}
export const postNotificationsMarkAsRead = (
  data: types.IPostNotificationsMarkAsReadParams
) => {
  return http.post<types.IPostNotificationsMarkAsReadData>(
    `/notifications/mark-as-read`,
    data
  )
}
